export const searchProduct = {
  name: 'Search',
  displayName: {
    source: {
      jsonPath: '$.displayName',
      resource: 'tenant',
    },
  },
  description:
    "Transform your website's search with Sitecore's AI-powered, intelligent search for websites and digital properties.",
  icon: {
    type: 'url',
    src: 'https://sitecorecontenthub.stylelabs.cloud/api/public/content/d287e838b00b4dc19b71bf8c09705dd0',
  },
  color: 'teal',
  baseUrl: {
    dev: 'https://cec-dev.sitecore-staging.cloud',
    qa: 'https://cec-qa.sitecore-staging.cloud',
    staging: 'https://cec-staging.sitecore-staging.cloud',
    'pre-production': 'https://cec-beta.sitecorecloud.io',
    production: 'https://cec.sitecorecloud.io',
  },
  link: {
    type: 'external-link',
    to: '{baseUrl}?organization={organizationId}&tenantId={tenantId}',
    replacements: [
      {
        key: 'baseUrl',
        source: {
          jsonPath: "$.baseUrl['#env#']",
          resource: '_self',
        },
      },
      {
        key: 'organizationId',
        source: {
          resource: 'tenant',
          jsonPath: '$.organizationId',
        },
      },
      {
        key: 'tenantId',
        source: {
          resource: 'tenant',
          jsonPath: '$.id',
        },
      },
    ],
  },
};
